var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"touchstart":function($event){return _vm.resetTimer()},"click":function($event){return _vm.resetTimer()}}},[_c('heading',{ref:"header"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }